"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// import tableImage from './tableCarpet.png';
var PlayAndPauseBak = 'RR_BK.png';
var BackSkip = 'Back_Skip.png';
var FWDSkip = 'FWD_SKIP.png';
var Back = 'Back.png';
var FWD = 'FWD.png';
var Stop = 'Stop.png';
var pause = 'pause.png';
var play = 'play.png';
// import './Control.css';
var baseUrl = "/images/handReplay/PartyPoker/";
var Control = /*#__PURE__*/function (_Component) {
  _inherits(Control, _Component);
  var _super = _createSuper(Control);
  function Control(props) {
    var _this;
    _classCallCheck(this, Control);
    _this = _super.call(this, props);
    _this.componentDidMount = function () {
      if (localStorage.getItem("loggedInType") === "Danskespil") {
        baseUrl = "/images/handReplay/Danskespil/";
      }
    };
    _this.backClick = function () {
      _this.props.stepBackward();
    };
    _this.fwdClick = function () {
      _this.props.stepForward();
    };
    _this.state = {
      backBtnStatus: true,
      fwdBtnStatus: false
    };
    return _this;
  }
  _createClass(Control, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("svg", {
        height: parseInt(this.props.height) + "%",
        width: parseInt(this.props.width) + "%",
        x: this.props.zx,
        y: this.props.zy
      }, this.props.isMultipleHands && /*#__PURE__*/_react["default"].createElement("image", {
        x: "55%",
        y: 88 + parseInt(this.props.cy) + "%",
        width: "5.5%",
        height: "12.5%",
        style: {
          cursor: "pointer"
        },
        onClick: this.props.refresh,
        href: baseUrl + this.props.replayImage
      }), /*#__PURE__*/_react["default"].createElement("image", {
        x: "62%",
        y: 84 + parseInt(this.props.cy) + "%",
        width: "20%",
        height: "20%",
        href: baseUrl + PlayAndPauseBak
      }), !this.props.isFirstSlide ? /*#__PURE__*/_react["default"].createElement("image", {
        x: "62.5%",
        y: 92 + parseInt(this.props.cy) + "%",
        width: "4%",
        height: "4%",
        style: {
          cursor: "pointer"
        },
        onClick: this.backClick,
        href: baseUrl + Back
      }, /*#__PURE__*/_react["default"].createElement("title", null, "Backward")) : /*#__PURE__*/_react["default"].createElement("image", {
        className: "overlayImg",
        x: "62.5%",
        y: 92 + parseInt(this.props.cy) + "%",
        width: "4%",
        height: "4%",
        style: {
          cursor: "pointer"
        },
        href: baseUrl + Back
      }, /*#__PURE__*/_react["default"].createElement("title", null, "Backward")), !this.props.playStatus ? /*#__PURE__*/_react["default"].createElement("image", {
        x: "65.4%",
        y: 90 + parseInt(this.props.cy) + "%",
        width: "7.8%",
        style: {
          cursor: "pointer"
        },
        onClick: this.props.play,
        height: "7.8%",
        href: baseUrl + play
      }, /*#__PURE__*/_react["default"].createElement("title", null, "Play")) : /*#__PURE__*/_react["default"].createElement("image", {
        x: "65.4%",
        y: 90 + parseInt(this.props.cy) + "%",
        width: "7.8%",
        height: "7.8%",
        style: {
          cursor: "pointer"
        },
        onClick: this.props.pause,
        href: baseUrl + pause
      }, /*#__PURE__*/_react["default"].createElement("title", null, "Pause")), /*#__PURE__*/_react["default"].createElement("image", {
        x: "71%",
        y: 90 + parseInt(this.props.cy) + "%",
        width: "7.8%",
        height: "7.8%",
        style: {
          cursor: "pointer"
        },
        onClick: this.props.stop,
        href: baseUrl + Stop
      }, /*#__PURE__*/_react["default"].createElement("title", null, "Stop")), !this.props.playStatus && !this.props.isLastSlide ? /*#__PURE__*/_react["default"].createElement("image", {
        x: "77.5%",
        y: 92 + parseInt(this.props.cy) + "%",
        width: "4%",
        height: "4%",
        style: {
          cursor: "pointer"
        },
        onClick: this.fwdClick,
        href: baseUrl + FWD
      }, /*#__PURE__*/_react["default"].createElement("title", null, "Forward")) : /*#__PURE__*/_react["default"].createElement("image", {
        className: "overlayImg",
        x: "77.5%",
        y: 92 + parseInt(this.props.cy) + "%",
        width: "4%",
        height: "4%",
        style: {
          cursor: "pointer"
        },
        href: baseUrl + FWD
      }, /*#__PURE__*/_react["default"].createElement("title", null, "Forward")), this.props.isMultipleHands && this.props.currentReplayerHandIndex !== 0 ? /*#__PURE__*/_react["default"].createElement("image", {
        x: "82%",
        y: 88 + parseInt(this.props.cy) + "%",
        width: "9%",
        height: "12.5%",
        style: {
          cursor: "pointer"
        },
        onClick: function onClick() {
          _this2.props.pause();
          _this2.props.prevHand();
        },
        href: baseUrl + BackSkip
      }) : this.props.isMultipleHands ? /*#__PURE__*/_react["default"].createElement("image", {
        x: "82%",
        y: 88 + parseInt(this.props.cy) + "%",
        width: "9%",
        height: "12.5%",
        style: {
          cursor: "pointer",
          opacity: "0.2"
        },
        href: baseUrl + BackSkip
      }) : null, this.props.isMultipleHands && this.props.currentReplayerHandIndex !== this.props.selectedHandCount - 1 ? /*#__PURE__*/_react["default"].createElement("image", {
        x: "88.5%",
        y: 88 + parseInt(this.props.cy) + "%",
        width: "9%",
        height: "12.5%",
        style: {
          cursor: "pointer"
        },
        onClick: function onClick() {
          _this2.props.pause();
          _this2.props.nextHand();
        },
        href: baseUrl + FWDSkip
      }) : this.props.isMultipleHands ? /*#__PURE__*/_react["default"].createElement("image", {
        x: "88.5%",
        y: 88 + parseInt(this.props.cy) + "%",
        width: "9%",
        height: "12.5%",
        style: {
          cursor: "pointer",
          opacity: "0.2"
        },
        href: baseUrl + FWDSkip
      }) : null);
    }
  }]);
  return Control;
}(_react.Component);
var _default = Control;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReplayTable/Control.js
 ** module id = 2381
 ** module chunks = 0
 **/